export default "__VITE_ASSET__NXtlrFlw__"